<div class="files-preview-container">

    <div class="file-input">
        <div class="image-uploader">
            <div class="upload-container">
                <label [attr.for]="'fileDropRef_' + managerIndex">
                    <input #fileDropRef (change)="fileBrowseHandler($event)" [hidden]="true"
                        accept=".png, .jpeg, .jpg" [attr.id]="'fileDropRef_' + managerIndex"
                        [disabled]="isDisabled" [multiple]="false" type="file" />
                    <div class="image-preview photo camera-fill">
                        <img *ngIf="!defualtImage && !SelectedImage">
                        <img *ngIf="SelectedImage || defualtImage " [src]="SelectedImage|| defualtImage"
                            class="bg-light" alt="image">
                    </div>
                </label>
            </div>
            <div>
                <label>{{label}}</label>
                <p>
                    {{ 'general.JPG or PNG' | translate }}
                    <span>({{ 'general.MB max' | translate:{no:2} }})</span>
                </p>
                <label [attr.for]="'fileDropRef_' + managerIndex">
                    <a>{{'general.Upload/Select File' | translate }}</a>
                </label>

            </div>
        </div>
    </div>

    <!-- <div *ngIf="!SelectedImage && !defualtImage && isSubmited" class="has-error">{{"form_message.Required" | translate}} </div> -->
    <div *ngIf="!validFile" class="has-error">{{"fileManager.Invalid File Extensions" | translate}}</div>
    <div *ngIf="fileMaxSiZeErorr" class="has-error">{{ "fileManager.Max File Size" | translate: { maxFileSize:
        maxFileSize } }}</div>
</div>